import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const contactsSlice = createSlice({
  name: "contacts",
  initialState,
  reducers: {
    contactsLoading(state) {
      state.loading = true;
      state.error = null;
    },
    contactsError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setContactsList(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
  },
});

export const { contactsLoading, contactsError, setContactsList } =
  contactsSlice.actions;

export default contactsSlice.reducer;
